if (!customElements.get('wlsn-heroblock')) {
    class WLSNHeroblock extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                fireworks: 'js-wlsn-heroblock-fireworks'
            };
            this.elements = {
                fireworks: this.querySelectorAll(`.${this.classes.fireworks}`)
            }
        }

        connectedCallback() {
            if (window.Fireworks) {
                this.initFireworks();
            } else {
                document.addEventListener('fireworks:ready', () => this.initFireworks(), { once: true });
            }
        }

        initFireworks() {
            if (this.elements.fireworks.length > 0) {
                const goldOptions = {
                    hue: { min: 45, max: 60 },
                    brightness: { min: 60, max: 80 },
                    decay: { min: 0.015, max: 0.03 }, 
                    particleCount: 70,
                    trace: 3,
                    traceSpeed: 2,
                };

                this.elements.fireworks.forEach(firework => {
                    const fireworks = new Fireworks.default(firework, goldOptions);
                    fireworks.start();
                });
            }
        }
    }

    customElements.define('wlsn-heroblock', WLSNHeroblock);
}
